function VzduchotechnickeZariadenia(){
    return(
        <div>
            VzduchotechnickeZariadenia
        </div>
    );
};

export default VzduchotechnickeZariadenia;